export function readableJobStatus(status) {
  if(status == 'waitingForTalentToApply'){
    return 'Waiting for talent to apply'
  }
  if(status == 'waitingForTalentToAccept'){
    return 'Waiting for talent to accept'
  }
  if(status === 'jobWaitingForThirdPartyPayAndTalentAccept')
  {
    return 'Waiting for third party to pay and for talent to accept';
  } 
  if(status === 'jobWaitingForThirdPartyPay')
  {
    return 'Talent has confirmed; waiting for third party to pay';
  }
  if(status === 'confirmedJob'){
    return 'Confirmed Job';
  }
  if(status === 'confirmedJob'){
    return 'Completed Job ';
  }
  return status;
}